module.exports = __webpack_public_path__ + "img/plax-1.2abb890a.jpg";